 
 import Contato from "../components/Contato";

function ContatoPage() {
  return (
    <div>
       <section id="Contato" className="scroll-mt-[60px] md:scroll-mt-[100px] lg:scroll-mt-[120px]"><Contato /></section>       
     </div>
  );
}

export default ContatoPage;
